import React, { Suspense, useCallback, useEffect, useState } from 'react';
import { Modal } from '../../Universal/NovusDSImports';
import { Polygon } from '@react-google-maps/api';
import { getCentroid } from '../../CommonUtilities/CommonUtilities';
import { PolygonPreviewModalType } from './shapes.types';
import PALoader from '../../SharedComponets/PALoader';
// import { PA_BOUNDARY } from '../../Constants/constants';
import Map from '../../SharedComponets/Map/Map';

const PolygonPreviewModal: React.FC<PolygonPreviewModalType> = ({
  editModeData
}) => {
  const [center, setCenter] = useState<any>({ lat: 24.886, lng: -70.268 });

  const onLoad = useCallback(
    (map) => {
      const bounds = new window.google.maps.LatLngBounds();

      editModeData.geometry.coordinates[0].forEach((point: any) => {
        bounds.extend({ lat: point[0], lng: point[1] });
      });

      map.fitBounds(bounds);
    },
    [editModeData?.geometry?.coordinates]
  );

  const onUnmount = useCallback((map) => {}, []);

  const getPolygonPath = (coords: any) => {
    const path: any = [];
    coords &&
      coords.forEach((point: any) => {
        path.push({ lat: point[0], lng: point[1] });
      });
    return path;
  };

  useEffect(() => {
    if (editModeData) {
      const value = getCentroid(editModeData.geometry.coordinates[0]);
      setCenter({ lat: value[1], lng: value[0] });
    }
  }, [editModeData]);

  const containerStyle = {
    width: '1000px',
    height: '500px'
  };

  return (
    <Suspense fallback={<PALoader />}>
      <Map
        data-testid="PolygonPreviewModal"
        id="PolygonPreviewModal"
        containerStyle={containerStyle}
        center={center}
        onLoad={onLoad}
        onUnmount={onUnmount}
        zoom={10}
        onClick={(event: google.maps.MapMouseEvent) => {
          event.stop();
        }}
        options={{
          maxZoom: 18,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false
          // restriction: {
          //   strictBounds: false,
          //   latLngBounds: PA_BOUNDARY
          // }
        }}
      >
        <Polygon
          onLoad={() => {}}
          paths={getPolygonPath(editModeData?.geometry?.coordinates[0])}
          options={{
            fillColor: 'red',
            fillOpacity: 0.2,
            strokeWeight: 3,
            strokeColor: 'red',
            clickable: false
          }}
        />
      </Map>
    </Suspense>
  );
};

export default Modal(React.memo(PolygonPreviewModal));
